import { HStack, View, VStack } from "@gluestack-ui/themed";
import { UIAuthLayoutProps } from "./types";
import {
  MOBILE_BOTTOM_BAR_ITEMS,
  SIDEBAR_NAVIGATION_ITEMS,
  HEADER_NAVIGATION_ITEMS,
  MOBILE_RESPONSIVE_MENU_ITEMS
} from "@repo/core/constants/menu.constants";
import { SideBar } from "@repo/core/components/layout/SideBar";
import { SideMenu } from "@repo/core/components/layout/SideMenu";
import { BottomBar } from "@repo/core/components/layout/BottomBar";
import { Drawer } from "@repo/core/components/layout/Drawer";
import { HeaderWebMenu } from "@repo/core/components/layout/HeaderWebMenu";

import { useAuthLayoutController } from "./controller";
import { Navigate } from "react-router-dom";
import { ROUTES } from "@repo/core/routes";
import { ModalTemplate } from "@repo/core/components/layout/ModalTemplate";

import { styles } from "./styles";

export const AuthLayout = ({
  showSideMenu = true,
  children
}: UIAuthLayoutProps) => {
  const {
    isMobile,
    user,
    mobileDrawerRef,
    modalRef,
    modalOptions,
    hasViewedWelcomePage,
    handleMenuItem
  } = useAuthLayoutController();

  if (!hasViewedWelcomePage) {
    return <Navigate to={ROUTES.welcome} />;
  }

  return (
    <>
      <VStack
        flex={1}
        bg="$backgroundLight100"
        // glustack not typed vh, so we need to cast it
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        height={isMobile ? ("90vh" as any) : "$100vh"}
        overflow={"hidden"}
      >
        <HeaderWebMenu
          items={HEADER_NAVIGATION_ITEMS}
          onItemPress={handleMenuItem}
          isMobile={isMobile}
          user={user}
        />
        <HStack flex={1}>
          {/* ASIDE */}
          {!isMobile && showSideMenu && (
            <HStack zIndex={2} height={"$100vh"}>
              <SideBar
                items={SIDEBAR_NAVIGATION_ITEMS}
                onItemPress={handleMenuItem}
              />
            </HStack>
          )}

          {/* MAIN */}
          <View
            zIndex={1}
            w="$full"
            pb={isMobile ? "$4" : "$0"}
            flex={1}
            height="auto"
            overflow="scroll"
          >
            {children}
          </View>
        </HStack>

        {/* MOBILE SIDE MENU */}
        {isMobile && (
          <>
            <div style={styles.bottomBarContainer as React.CSSProperties}>
              <BottomBar
                items={MOBILE_BOTTOM_BAR_ITEMS}
                onItemPress={handleMenuItem}
              />
            </div>
            <Drawer ref={mobileDrawerRef} width={"$85vw"}>
              <SideMenu
                items={MOBILE_RESPONSIVE_MENU_ITEMS}
                headerTitle={user?.name || "User"}
                headerSubtitle="[Cargo]"
                onItemPress={handleMenuItem}
              />
            </Drawer>
          </>
        )}
      </VStack>

      <ModalTemplate.Options
        ref={modalRef}
        title="Sair do app"
        text="Você tem certeza que deseja sair?"
        options={modalOptions}
      />
    </>
  );
};
